import { useEffect, useRef, useState, useMemo } from "react";
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import axios from 'axios';

import useIsMobile from "../../hooks/useIsMobile";

import SelectStylist from "./Components/SelectStylist";

// import useStylistsStore from "../../store/stylists";
import useLocalStylistsStore from "../../store/stylists/local";

import { useNewEvent } from "../../contexts/NewEvent";

import useAuth from "../../hooks/useAuth";
import { BasicFlex } from "../../utils/Common";

import { Card, CardContent, Button, IconButton } from "@mui/material";

import SimpleChip from "../../utils/utilities/SimpleChip";

import { dimensions, mockEvents,
  TimelineTableHead,
  TimelineIconContainer,
  TimelineRibbon,

 } from "./Common";

import WatchLaterIcon from '@mui/icons-material/WatchLater';

import {HebrewCalendar, HDate, Location, Event, HebrewDateEvent} from '@hebcal/core';

import AppointmentStatus from '../Appointments/Components/AppointmentStatus';

import { getYPos, roundMinutesToNearestPoint, roundToPointOfHourTime, findEventInDate, constructDate, getWeekRange, getWeekDay, getMonthName } from './helpers';

import useDateEvents from "../../hooks/timeline/useDateEvents";

import { formatCurrency, formatGenericTime } from "../../utils/util";

import ModifyAppointment from "../Appointments/Components/ModifyAppointment";

import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';


const Container = styled(BasicFlex)`
  margin: 1rem 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`

const SectionList = styled(BasicFlex)`

`

const SectionTileStyles = styled(BasicFlex)`
  align-items: stretch;
`

const TimestampDisplayStyles = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.darkBg};
  min-width: 8.5rem;
  padding: 1.5rem;
  border-radius: 8px;
`

const TimestampMonth = styled.div`
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.2rem;
`

const TimestampDay = styled.div`
  font-weight: 500;
  font-size: 1.6rem;
  margin: .2rem 0;
`

const TimestampHebrewDate = styled.div`
  font-weight: 500;
  font-size: 1.4rem;
  font-family: 'Bona Nova';
`

const EventTileList = styled(BasicFlex)`

`

const EventTileContainer = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.lightBg};
  border-radius: 8px;
  padding: .4rem 1.5rem;
  padding-top: 1rem;
`

const EventTileInfoBar = styled(BasicFlex)`

`

const EventTileStyles = styled(BasicFlex)`
  

`

const InfoTileStyles = styled(BasicFlex)`
  flex-basis: 0;
  flex-grow: 1;
`

const InfoTileMain = styled.div`
  font-weight: 500;
`

const InfoTileSub = styled.div`
  color: ${props => props.theme.colors.mildText};
`

const StatusBar = styled(BasicFlex)`
  width: 25%;
  gap: .8rem;
  justify-content: flex-end;
`

const ActionBar = styled(BasicFlex)`
  justify-content: flex-end;
`

const DateSpan = styled.span`
  font-weight: 500;
  text-transform: uppercase;
`

const TimelineActions = styled(BasicFlex)`
  padding: 0 1rem;
`

const TimestampDisplay = ({timestamp, period}) => {

  let hDate = new HDate(timestamp);
  let hebDate = new HebrewDateEvent(hDate)

  return (
    <TimestampDisplayStyles dir="column" justify="flex-start" align="center" width="none">
      <TimestampMonth>{getWeekDay(timestamp)}</TimestampMonth>
      <TimestampDay>{getMonthName(timestamp)} {hDate.getDate()}</TimestampDay>
      <TimestampHebrewDate>{hebDate.renderBrief('he-x-NoNikud')}</TimestampHebrewDate>
    </TimestampDisplayStyles>
  )

}

const InfoTile = ({ title, sub }) => {
  return (
    <InfoTileStyles dir="column" gap=".6rem" width="none">
      <InfoTileMain>{title}</InfoTileMain>
      <InfoTileSub>{sub}</InfoTileSub>
    </InfoTileStyles>
  )
}

const SectionTile = ({ timestamp, events = [], period}) => {

  const [expand, setExpand] = useState({

  });

  const handleExpand = (id) => {
    setExpand(expand => ({...expand, [id]: !expand[id]}));
  }

  timestamp = new Date(timestamp);

  return (
    <SectionTileStyles gap="1rem">
      <TimestampDisplay timestamp={timestamp} period={period} />
      <EventTileList dir="column" gap="1rem">
        {events.map((event, index) => {
          let { start_time, end_time, customer, title, duration_in_minutes, stylist = "M Klein", subtotal } = event;
          let apptTime = `${formatGenericTime(start_time)} - ${formatGenericTime(end_time)}`
          return (
            <EventTileContainer key={event.appointment_id} dir="column" gap=".2rem">
              <EventTileInfoBar>
                <EventTileStyles>
                  <InfoTile title={customer} sub={apptTime} />
                  <InfoTile title={title} sub={`${duration_in_minutes} Min`} />
                  <InfoTile title={<SimpleChip label={stylist} />} sub={formatCurrency(subtotal)} />
                </EventTileStyles>
                <StatusBar>
                  <AppointmentStatus event={event} />
                  {/* <Button>View</Button> */}
                </StatusBar>
              </EventTileInfoBar>
              <BasicFlex justify="flex-end">
                <IconButton size="small" onClick={() => {handleExpand(event.appointment_id)}}><MoreHorizRoundedIcon /></IconButton>
              </BasicFlex>
             {expand?.[event.appointment_id] && <ActionBar>
               <ModifyAppointment event={event} />
             </ActionBar>}
            </EventTileContainer>
          )
        })}
      </EventTileList>
    </SectionTileStyles>
  )

}

const ListView = ({ curDate = {} }) => {

  let activeStylists = useLocalStylistsStore(state => state.activeStylists);

  const [period, setPeriod] = useState('week');

  let { start, end } = useMemo(() => getWeekRange(curDate), [curDate])
  let { dates = [], hebDates = [], hebEventsByDate = [], scheduledEvents = [], dayOfWeek, filterByStylist, filterByDay, filterHebEvents, workingHours, filterWorkingHours } = useDateEvents({start_date: start, end_date: end, range_type: 'week', stylists: activeStylists.filter(el => el.checked).map(el => el.stylist_id)});

  console.log(scheduledEvents, dates, "scheduledEvents");
  let from = `${getMonthName(start)} ${start.getDate()}`
  let to = `${getMonthName(end)} ${end.getDate()}`

  return (
    <Container>
      <TimelineTableHead>
        <TimelineRibbon>
          <TimelineIconContainer>
            <WatchLaterIcon fontSize="large" />
          </TimelineIconContainer>
          <TimelineActions>
            <div>
              <DateSpan>{from}</DateSpan> &nbsp; -  &nbsp;<DateSpan>{to}</DateSpan>
            </div>
            <Button variant="contained" color="secondary">New Appointment</Button>
          </TimelineActions>
        </TimelineRibbon>
      </TimelineTableHead>
      <Card sx={{width: "100%"}} elevation={0}>
        <CardContent>
          <SectionList dir="column" gap="3rem">
            {dates.map((date, index) => {
              let filteredEvents = filterByDay(date, scheduledEvents);
              return (
              <SectionTile key={getWeekDay(date)} timestamp={date} events={filteredEvents} period={period} />
            )})}
          </SectionList>
        </CardContent>
      </Card>
    </Container>
  )

};

export default ListView;